const checkItemsClassName = '.js-toggle-checkbox-form-item'

function toggleSubmitButton() {
  const submitButton = document.querySelector('.js-toggle-checkbox-form-submit')
  if (submitButton === null) return

  const checkedCounts = document.querySelectorAll(`${checkItemsClassName}:checked`).length
  const disalbedClass = 'c-button-disabled'

  // チェックされているチェックボックスがない場合はsubmitボタンを非活性にする
  if (checkedCounts > 0) {
    submitButton.classList.remove(disalbedClass)
    return
  }
  submitButton.classList.add(disalbedClass)
}

export function toggleCheckboxSubmit() {
  const form = document.getElementById('js-toggle-checkbox-form')
  const checkItems = document.querySelectorAll(checkItemsClassName)
  if (form === null || checkItems.length === 0) return

  toggleSubmitButton()
  checkItems.forEach((el) => {
    el.addEventListener('click', () => {
      toggleSubmitButton()
    })
  })
}
